import { useRequestQuote } from "../../context/RequestQuoteContext";

import { Fragment, JSX, ReactNode, useEffect } from "react";

export function FinishConfiguration({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const { setEnableRequestQuote } = useRequestQuote();

  useEffect(() => {
    setEnableRequestQuote(true);

    return () => {
      setEnableRequestQuote(false);
    };
  }, [setEnableRequestQuote]);

  return <Fragment>{children}</Fragment>;
}
